import {
  request,
  useEndpointsContext,
  type IOrderConfigurationSnapshot,
  type MinimalSubscriptionResponse,
} from '@talos/kyoko';
import { useQuery } from '@tanstack/react-query';

const CONFIG_SNAPSHOT_ID = 'CONFIG_SNAPSHOT' as const;

const generateConfigSnapshotQueryID = (id?: string) => {
  return [CONFIG_SNAPSHOT_ID, '/', id];
};

export function useConfigSnapshotQuery(orderId?: string) {
  const { orgApiEndpoint } = useEndpointsContext();

  return useQuery<IOrderConfigurationSnapshot>({
    enabled: !!orderId,
    queryKey: generateConfigSnapshotQueryID(orderId),
    staleTime: Infinity,
    queryFn: async () =>
      request<MinimalSubscriptionResponse<IOrderConfigurationSnapshot>>(
        'GET',
        `${orgApiEndpoint}/orders/${orderId}/config-snapshot`
      ).then(response => {
        return response.data[0];
      }),
  });
}
